import {createSelector} from 'reselect';

const selectWorkspaces = (state) => state.workspaces;

export const selectLastCrawlId = createSelector(
    [selectWorkspaces],
    (workspaces) =>
        workspaces?.current?.lastCrawls?.length ? workspaces.current.lastCrawls[0].id : null
);
